/**
 * The notification service.
 * @author Tony Laurent <t.laurent@apodispharma.com>
 * @returns {Object} The public object.
 */
export default function () {
    return {
        /**
         * Create a notification.
         * @param {string} title - The title of the notification.
         * @param {string} body - The body of the notification.
         * @returns {Notification} The notification instance.
         */
        create(title: string, body: string): Notification {
            return new Notification(title, {body});
        },
        /**
         * Display the notification window.
         *
         * The bounds are computed by the caller; on older apps without the
         * placement primitives, the main process positions the window from
         * the height and the position setting.
         *
         * @param {number|undefined} height - The window height
         * @param {object|undefined} bounds - The window bounds to apply before showing
         *
         * @returns {void}
         */
        showNotification(height: number | undefined = undefined, bounds: object | undefined = undefined): void {
            window.ipcRenderer.send('show-notification', {
                height,
                bounds
            });
        },
        /**
         * Hide the notification window.
         */
        hideNotification(): void {
            window.ipcRenderer.send('hide-notification');
        }
    };
}
